import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface MessageSourcesProps {
  sources: { content: string }[];
}

export function MessageSources({ sources }: MessageSourcesProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mt-2 border-t border-border/50 pt-2">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors"
      >
        <ChevronDown
          className={cn("size-3 transition-transform", isOpen && "rotate-180")}
        />
        {`${isOpen ? t("chat.hideSources") : t("chat.showSources")} (${sources.length})`}
      </button>
      {isOpen && (
        <ul className="mt-1.5 space-y-1">
          {sources.map((source, index) => (
            <li
              key={index}
              className="text-xs text-muted-foreground pl-4 border-l-2 border-border"
            >
              {source.content}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
